import mitt from "mitt";

import {Emitter} from "@sentrei/common/models/Snackbar";

const emitter = mitt();

// eslint-disable-next-line import/prefer-default-export
export const SnackbarEmitter: Emitter = {
  off: emitter.off,
  on: emitter.on,
  emit: emitter.emit,
};
